import React from 'react';
import { Icons } from '@marageti/z4-lib';
import { PartnerStatus } from '@marageti/z4-sdk/lib/travel';
import { UserStatus } from '@marageti/z4-sdk/lib/auth';

// eslint-disable-next-line import/prefer-default-export
export const partnerStatusIcons = {
  [PartnerStatus.ONBOARDING]: {
    displayName: 'Onboarding',
    icon: <Icons.Sparkles sx={{ color: '#868B8C', transform: 'scaleX(-1)' }} titleAccess="Onboarding" />,
  },
  [PartnerStatus.NEW]: {
    displayName: 'New',
    icon: <Icons.Sparkles sx={{ color: '#0089FC' }} titleAccess="New" />,
  },
  [PartnerStatus.ACTIVE]: {
    displayName: 'Active',
    icon: <Icons.StatusOnline sx={{ color: '#008147' }} titleAccess="Active" />,
  },
  [PartnerStatus.NON_STRATEGIC]: {
    displayName: 'Non Strategic',
    icon: <Icons.StatusOnline sx={{ color: '#FF9800' }} titleAccess="Non-Strategic" />,
  },
  [PartnerStatus.PHASING_OUT]: {
    displayName: 'Phasing Out',
    icon: <Icons.StatusOnline sx={{ color: '#E0002B' }} titleAccess="Phasing Out" />,
  },
  [PartnerStatus.INACTIVE]: {
    displayName: 'Inactive',
    icon: <Icons.StatusOffline sx={{ color: '#868B8C' }} titleAccess="Inactive" />,
  },
};

export const peopleStatusIcons = {
  [UserStatus.ENABLED]: {
    displayName: 'Enabled',
    icon: <Icons.StatusOnline sx={{ color: 'success.dark' }} titleAccess="Enabled" />,
  },
  [UserStatus.PENDING]: {
    displayName: 'Pending',
    icon: <Icons.Sparkles sx={{ color: 'secondary.main' }} titleAccess="Pending" />,
  },
  [UserStatus.DISABLED]: {
    displayName: 'Disabled',
    icon: <Icons.StatusOffline color="disabled" titleAccess="Disabled" />,
  },
};
